import { useState, useRef, useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom";
import TextInput from "../Components/Form/TextInput"
import Form from "../Components/Form"
import Workspace from "../APIController/Workspace"
import NumberInput from "../Components/Form/NumberInput"
import { loadGoogleMapsAPI } from "../utils/loadGoogleMaps"

export const WorkspaceFindForm = ({ resultAction = null, redirect = "", preAddress = "", preRad = 1 }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { findWorkspaceNear } = Workspace()
    const [address, setAddress] = useState("")
    const [rad, setRad] = useState(1)
    const [coordinates, setCoordinates] = useState(null)
    const [isGoogleLoaded, setIsGoogleLoaded] = useState(false)
    const autocompleteRef = useRef(null)
    const inputRef = useRef(null)
    const hasInitialized = useRef(false)

    useEffect(() => {
        const urlAddress = searchParams.get('address')
        const urlRad = searchParams.get('rad')

        const initialAddress = urlAddress || preAddress
        const initialRad = urlRad ? parseInt(urlRad) : preRad

        setAddress(initialAddress)
        setRad(initialRad)

        if (initialAddress && initialRad && !hasInitialized.current) {
            hasInitialized.current = true
            setTimeout(() => {
                geocodeAddress(initialAddress)
            }, 500)
        }
    }, [searchParams, preAddress, preRad])

    useEffect(() => {
        loadGoogleMapsAPI()
            .then(() => {
                setIsGoogleLoaded(true)
            })
            .catch((error) => {
                console.error('Fehler beim Laden der Google Maps API:', error)
            })
    }, [])

    useEffect(() => {
        if (isGoogleLoaded && inputRef.current && !autocompleteRef.current) {
            autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
                types: ['geocode'],
                componentRestrictions: { country: 'ch' }
            })

            autocompleteRef.current.addListener('place_changed', () => {
                const place = autocompleteRef.current.getPlace()

                if (place.geometry) {
                    setAddress(place.formatted_address)
                    setCoordinates({
                        lat: place.geometry.location.lat(),
                        lon: place.geometry.location.lng()
                    })
                }
            })
        }
    }, [isGoogleLoaded])

    const geocodeAddress = async (addr) => {
        if (!window.google) {
            console.warn('Google Maps noch nicht geladen')
            return
        }

        const geocoder = new window.google.maps.Geocoder()
        geocoder.geocode({ address: addr }, (results, status) => {
            if (status === 'OK' && results[0]) {
                const coords = {
                    lat: results[0].geometry.location.lat(),
                    lon: results[0].geometry.location.lng()
                }
                setCoordinates(coords)
                fetchData(coords.lat, coords.lon)
            } else {
                console.error('Geocoding fehlgeschlagen:', status)
            }
        })
    }

    const fetchData = async (lat, lon) => {
        const data = await findWorkspaceNear(lat, lon, rad)
        if (resultAction) resultAction(data, address, lat, lon)
    }

    const submitAction = async (e) => {
        e.preventDefault()

        if (!address) return

        if (redirect) {
            navigate(`/search?address=${encodeURIComponent(address)}&rad=${rad}`)
        } else if (coordinates) {
            fetchData(coordinates.lat, coordinates.lon)
        } else {
            geocodeAddress(address)
        }
    }

    return (
        <Form onSubmitAction={submitAction} submitButtonText={"Suchen"} border="p-3 rounded-lg shadow-lg">
            <div className="w-full flex md:flex-row flex-col gap-4">
                <TextInput
                    ref={inputRef}
                    attribute={address}
                    id={"address"}
                    label={"Adresse oder Ort"}
                    action={(e) => setAddress(e.target.value)}
                    placeholder={"z.B. Zürich, Bahnhofstrasse 1"}
                    required={true}
                />

                <NumberInput
                    attribute={rad}
                    id={"rad"}
                    label={"Radius in KM"}
                    action={(e) => setRad(e.target.value)}
                    required={true}
                />
            </div>
        </Form>
    )
}